/**
 * @generated SignedSource<<cd9b1fcf45730d93ccd812e43ee25d8f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NotificationsTabQuery$variables = {
  id: string;
};
export type NotificationsTabQuery$data = {
  readonly brand: {
    readonly " $fragmentSpreads": FragmentRefs<"NotificationsTab_brand" | "NotificationsTab_brandPendingNotifications">;
  };
};
export type NotificationsTabQuery = {
  response: NotificationsTabQuery$data;
  variables: NotificationsTabQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "after",
  "value": ""
},
v4 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v5 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "confirmationStatus": {
        "exact": "confirmed"
      }
    }
  },
  (v4/*: any*/)
],
v6 = [
  (v2/*: any*/)
],
v7 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "GraphQLNotificationEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLNotification",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uuid",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "audienceLanguages",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "automaticArchiveTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "body",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "confirmationStatus",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "thumbnailUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "externalThumbnailUri",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isArchived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "landingPath",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "utmCampaign",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLCDPAudience",
            "kind": "LinkedField",
            "name": "audiences",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "audienceName",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLDailyDeal",
            "kind": "LinkedField",
            "name": "dailyDeal",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLFeedPost",
            "kind": "LinkedField",
            "name": "feedPost",
            "plural": false,
            "selections": (v6/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLHighlight",
            "kind": "LinkedField",
            "name": "highlight",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "GraphQLHighlightAlbum",
                "kind": "LinkedField",
                "name": "highlightAlbum",
                "plural": false,
                "selections": (v6/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cursor",
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "PageInfo",
    "kind": "LinkedField",
    "name": "pageInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endCursor",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNextPage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v8 = [
  (v3/*: any*/),
  {
    "kind": "Literal",
    "name": "filters",
    "value": {
      "confirmationStatus": {
        "exact": "pending"
      }
    }
  },
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationsTab_brand"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "NotificationsTab_brandPendingNotifications"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsTabQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "BrandType",
        "kind": "LinkedField",
        "name": "brand",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "GraphQLNotificationConnection",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": "notifications(after:\"\",filters:{\"confirmationStatus\":{\"exact\":\"confirmed\"}},first:10)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "NotificationsTab_notifications",
            "kind": "LinkedHandle",
            "name": "notifications"
          },
          {
            "alias": "pendingNotifications",
            "args": (v8/*: any*/),
            "concreteType": "GraphQLNotificationConnection",
            "kind": "LinkedField",
            "name": "notifications",
            "plural": false,
            "selections": (v7/*: any*/),
            "storageKey": "notifications(after:\"\",filters:{\"confirmationStatus\":{\"exact\":\"pending\"}},first:10)"
          },
          {
            "alias": "pendingNotifications",
            "args": (v8/*: any*/),
            "filters": [],
            "handle": "connection",
            "key": "NotificationsTab_pendingNotifications",
            "kind": "LinkedHandle",
            "name": "notifications"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f3bc75c044b1b24f1de2312c423f9c0e",
    "id": null,
    "metadata": {},
    "name": "NotificationsTabQuery",
    "operationKind": "query",
    "text": "query NotificationsTabQuery(\n  $id: ID!\n) {\n  brand(id: $id) {\n    ...NotificationsTab_brand\n    ...NotificationsTab_brandPendingNotifications\n    id\n  }\n}\n\nfragment NotificationTableRow_notification on GraphQLNotification {\n  id\n  uuid\n  audienceLanguages\n  automaticArchiveTimestamp\n  body\n  confirmationStatus\n  thumbnailUrl\n  externalThumbnailUri\n  isArchived\n  landingPath\n  timestamp\n  title\n  utmCampaign\n  audiences {\n    audienceName\n    id\n  }\n  dailyDeal {\n    id\n  }\n  feedPost {\n    id\n  }\n  highlight {\n    id\n    highlightAlbum {\n      id\n    }\n  }\n}\n\nfragment NotificationsTab_brand on BrandType {\n  id\n  notifications(first: 10, after: \"\", filters: {confirmationStatus: {exact: \"confirmed\"}}) {\n    edges {\n      node {\n        id\n        ...NotificationTableRow_notification\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment NotificationsTab_brandPendingNotifications on BrandType {\n  id\n  pendingNotifications: notifications(first: 10, after: \"\", filters: {confirmationStatus: {exact: \"pending\"}}) {\n    edges {\n      node {\n        id\n        ...NotificationTableRow_notification\n        __typename\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9bb7f7448dcdc03bb93393de7ad233a";

export default node;
